module.exports = __webpack_public_path__ + "static/media/pp_modified_icon.599cb396.svg";